import { render, staticRenderFns } from "./MtsTebligatView.vue?vue&type=template&id=39cf94e2"
import script from "./MtsTebligatView.vue?vue&type=script&lang=ts"
export * from "./MtsTebligatView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports